/*---------------------------------------------------
header
---------------------------------------------------*/
(() => {
  const root = document.getElementById('anshiki-page');
  if (!root) return;

  const drawer = root.querySelector('#lp02-drawer');
  const openBtn = root.querySelector('.js-lp02-drawer-open');
  const closeEls = root.querySelectorAll('.js-lp02-drawer-close, .lp02-drawer__list a');
  const activeClass = 'is-lp02-drawer-open';

  if (!drawer || !openBtn) return;

  const openDrawer = () => {
    root.classList.add(activeClass);
    drawer.setAttribute('aria-hidden', 'false');
    openBtn.setAttribute('aria-expanded', 'true');
    document.documentElement.style.overflow = 'hidden';
  };

  const closeDrawer = () => {
    root.classList.remove(activeClass);
    drawer.setAttribute('aria-hidden', 'true');
    openBtn.setAttribute('aria-expanded', 'false');
    document.documentElement.style.overflow = '';
  };

  openBtn.addEventListener('click', () => {
    if (root.classList.contains(activeClass)) {
      closeDrawer();
    } else {
      openDrawer();
    }
  });

  closeEls.forEach((el) => {
    el.addEventListener('click', closeDrawer);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && root.classList.contains(activeClass)) {
      closeDrawer();
      openBtn.focus();
    }
  });
})();

/*---------------------------------------------------
footer
---------------------------------------------------*/
new function () {
  var footerId = "footer";
  //メイン
  function footerFixed() {
    //ドキュメントの高さ
    var dh = document.getElementsByTagName("body")[0].clientHeight;
    //フッターのtopからの位置
    document.getElementById(footerId).style.top = "0px";
    var ft = document.getElementById(footerId).offsetTop;
    //フッターの高さ
    var fh = document.getElementById(footerId).offsetHeight;
    //ウィンドウの高さ
    if (window.innerHeight) {
      var wh = window.innerHeight;
    } else if (document.documentElement && document.documentElement.clientHeight != 0) {
      var wh = document.documentElement.clientHeight;
    }
    if (ft + fh < wh) {
      document.getElementById(footerId).style.position = "relative";
      document.getElementById(footerId).style.top = (wh - fh - ft - 1) + "px";
    }
  }

  //文字サイズ
  function checkFontSize(func) {
    //判定要素の追加 
    var e = document.createElement("div");
    var s = document.createTextNode("S");
    e.appendChild(s);
    e.style.visibility = "hidden"
    e.style.position = "absolute"
    e.style.top = "0"
    document.body.appendChild(e);
    var defHeight = e.offsetHeight;
    //判定関数
    function checkBoxSize() {
      if (defHeight != e.offsetHeight) {
        func();
        defHeight = e.offsetHeight;
      }
    }
    setInterval(checkBoxSize, 1000)
  }
  //イベントリスナー
  function addEvent(elm, listener, fn) {
    try {
      elm.addEventListener(listener, fn, false);
    } catch (e) {
      elm.attachEvent("on" + listener, fn);
    }
  }

  addEvent(window, "load", footerFixed);
  addEvent(window, "load", function () {
    checkFontSize(footerFixed);
  });
  addEvent(window, "resize", footerFixed);
}

/*---------------------------------------------------
faq
---------------------------------------------------*/
document.addEventListener('DOMContentLoaded', function () {
  const faqItems = document.querySelectorAll('.faq__list__item');

  if (!faqItems.length) {
    return;
  }

  faqItems.forEach(function (item) {
    const question = item.querySelector('.faq__list__item__question');
    const answer = item.querySelector('.faq__list__item__answer');

    if (!question || !answer) {
      return;
    }

    question.setAttribute('role', 'button');
    question.setAttribute('tabindex', '0');
    question.setAttribute('aria-expanded', 'false');

    answer.style.height = '0px';

    function toggleFaq() {
      const isOpen = item.classList.contains('is-open');

      if (isOpen) {
        answer.style.height = answer.scrollHeight + 'px';

        requestAnimationFrame(function () {
          answer.style.height = '0px';
        });

        item.classList.remove('is-open');
        question.setAttribute('aria-expanded', 'false');
      } else {
        item.classList.add('is-open');
        question.setAttribute('aria-expanded', 'true');
        answer.style.height = answer.scrollHeight + 'px';

        answer.addEventListener('transitionend', function onTransitionEnd() {
          if (item.classList.contains('is-open')) {
            answer.style.height = 'auto';
          }

          answer.removeEventListener('transitionend', onTransitionEnd);
        });
      }
    }

    question.addEventListener('click', toggleFaq);

    question.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggleFaq();
      }
    });
  });
});


/*---------------------------------------------------
Youtube再生
---------------------------------------------------*/
document.addEventListener('DOMContentLoaded', function () {
  /*
   * true  = クリックでYouTube再生
   * false = クリックしても再生しない
   */
  const YOUTUBE_PLAY_ENABLED = true;

  const youtubeBlocks = document.querySelectorAll('.js-youtube');

  if (!youtubeBlocks.length) {
    return;
  }

  youtubeBlocks.forEach(function (block) {
    const button = block.querySelector('.js-youtube-button');
    const youtubeId = block.dataset.youtubeId;

    if (!button || !youtubeId) {
      return;
    }

    button.addEventListener('click', function (e) {
      e.preventDefault();

      if (!YOUTUBE_PLAY_ENABLED) {
        return;
      }

      const iframe = document.createElement('iframe');

      iframe.setAttribute('src', 'https://www.youtube.com/embed/' + youtubeId + '?autoplay=1&rel=0&playsinline=1');
      iframe.setAttribute('title', 'YouTube video player');
      iframe.setAttribute('frameborder', '0');
      iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
      iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
      iframe.setAttribute('allowfullscreen', '');

      block.innerHTML = '';
      block.appendChild(iframe);
    });
  });
});